/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ArticlePublisherIdIdPreviewLanguageIdGet$Params {
  publisherId: string;
  id: string;
  languageId: string;
}

export function articlePublisherIdIdPreviewLanguageIdGet(http: HttpClient, rootUrl: string, params: ArticlePublisherIdIdPreviewLanguageIdGet$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, articlePublisherIdIdPreviewLanguageIdGet.PATH, 'get');
  if (params) {
    rb.path('publisherId', params.publisherId, {});
    rb.path('id', params.id, {});
    rb.path('languageId', params.languageId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as MediaStrictHttpResponse<void>;
    })
  );
}

articlePublisherIdIdPreviewLanguageIdGet.PATH = '/Article/{publisherId}/{id}/Preview/{languageId}';
